<script lang="ts">
	import type OptionCategory from "../../../class/StoreItem/OptionCategory";
	//
	import {
		AdaptiveTextInput,
		DefaultButton,
		DefaultSwitch,
		InlineButton,
	} from "@hitit/new_ui";
	import CollectionPopup from "../CollectionPopup.svelte";
	//Utils
	import { createEventDispatcher } from "svelte";
	import { clickOutside } from "@hitit/utils";
	import { getKeyInTranslation } from "../../../utils";
	import { t } from "@hitit/hub/src/stores";

	export let optionCategory: OptionCategory;
	export let disabled = false;
	export let clickOutsideCallBack = () => {};

	let inputValue = getKeyInTranslation(
		optionCategory.getTranslations(),
		"name",
		"ko"
	);

	const dispatch = createEventDispatcher();
	const deleteEvent = () => dispatch("DELETE_OPTION_CATEGORY", optionCategory);
	const parsingChecked = (e: Event) => {
		const target = e.target as HTMLInputElement;
		return target.checked;
	};

	const multipleSelectHandler = (e: Event) => {
		const checked = parsingChecked(e);
		const optionType = checked ? "MULTISELECT" : "SINGLESELECT";
		const dto = optionCategory.getOptionCategoryDTO();
		dto.optionType = optionType;
		dispatch("UPDATE_COLLECTION", dto);
	};

	const mandatoryHandler = (e: Event) => {
		const checked = parsingChecked(e);
		const dto = optionCategory.getOptionCategoryDTO();
		dto.mandatory = checked;
		dispatch("UPDATE_COLLECTION", dto);
	};

	const taxableHandler = (e: Event) => {
		const checked = parsingChecked(e);
		const dto = optionCategory.getOptionCategoryDTO();
		dto.taxable = checked;

		dispatch("UPDATE_COLLECTION", dto);
	};
	const nameButtonHandler = () => {
		const defaultTranslation = optionCategory
			.getTranslations()
			.find((v) => v.defaultLang && v.lang === "ko");
		const dto = optionCategory.getOptionCategoryDTO();

		if (defaultTranslation) {
			defaultTranslation.name = inputValue || "";
			dto.translationDTOs = [
				...optionCategory
					.getTranslations()
					.filter((v) => !(v.defaultLang && v.lang === "ko")),
				Object.assign({}, defaultTranslation),
			];
		}

		dto.internalName = inputValue || "";
		dispatch("UPDATE_COLLECTION", dto);
	};

</script>

<div class="container" use:clickOutside={clickOutsideCallBack}>
	<CollectionPopup>
		<div class="inner">
			<div class="f-col">
				<label for="">{$t('global.product.options.edit_option_name')}</label>
				<div class="input-button">
					<div class="input">
						<AdaptiveTextInput
							bind:value={inputValue}
							placeholder={$t('global.product.options.edit_option_name')} />
					</div>
					<div class="button">
						<DefaultButton
							on:click={nameButtonHandler}
							fitmode
							nonePadding
							disabled={disabled}>
							<span class="button-inner">{$t('global.save')}</span>
						</DefaultButton>
					</div>
				</div>
			</div>
			<div class="f-col">
				<div class="f-between">
					<label for="">{$t('global.product.options.mandatory')}</label>
					<DefaultSwitch
						on:change={mandatoryHandler}
						disabled={disabled}
						checked={optionCategory.mandatory} />
				</div>
				<p class="desc">
					{$t('global.product.options.must_be_selected_as_mandatory')}
				</p>
			</div>
			<div class="f-col">
				<div class="f-between">
					<label for="">{$t('global.product.options.multiple_select')}</label>
					<DefaultSwitch
						on:change={multipleSelectHandler}
						disabled={disabled}
						checked={optionCategory.optionType === 'MULTISELECT'} />
				</div>
				<p class="desc">
					{$t('global.product.options.multiple_selection_possible')}
				</p>
			</div>
			<div class="f-between">
				<label for="">{$t('global.product.category.taxable')}</label>
				<DefaultSwitch
					on:change={taxableHandler}
					disabled={disabled}
					checked={optionCategory.taxable} />
			</div>
			<div class="seperate" />
			<div class="f-between">
				<label for="">{$t('global.product.options.delete_option')}</label>
				<InlineButton on:click={deleteEvent} disabled={disabled}>
					<img id="delete" src="/icons/deleteIcon.png" alt="" />
				</InlineButton>
			</div>
		</div>
	</CollectionPopup>
</div>

<style lang="scss">
	@import "../../../../variables.scss";

	.container {
		position: absolute;
		left: 0;
		top: 46px;
		z-index: 9;

		&:hover {
			cursor: default;
		}

		#delete {
			width: 26px;
			height: 26.2px;
		}

		.seperate {
			width: 100%;
			height: 1px;
			background-color: #bcbfc3;
		}

		.inner {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		.button-inner {
			color: white;
			font-weight: 500;
			font-size: 1rem;
			line-height: 26px;
		}

		.desc {
			color: #e6e7ed;
			font-size: 0.875rem;
		}

		.f-between {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.input-button {
			display: flex;
			gap: 10px;
			height: 32px;

			.input {
				font-size: 1rem;
				color: #46474b;
				flex-grow: 1;
			}

			.button {
				width: 60px;
			}
		}

		.f-col {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		label {
			color: white;
		}
	}

	@include DesktopSize {
		.container {
			.inner {
				gap: 24px;
			}

			.button-inner {
				font-size: 1.25rem;
			}

			.input-button {
				height: 40px;
			}

			label {
				font-size: 1.25rem;
			}
		}
	}

</style>
